import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import AllCompaniesTable from "../Items/Table/AllCompaniesTable";
import UpdateCompanyNameModal from "../Modals/UpdateCompanyNameModal";

const AllCompaniesComponent = () => {
  const navigate = useNavigate();

  const { openNotification, contextHolder } = useMultiNotification();
  const [companies, setCompanies] = useState<CompanyProp[]>([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<CompanyProp | null>(null);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/getAllCompanies");

  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      setCompanies(data || []);
    }
  }, [apiResponse]);
  
  useEffect(() => {
    postApiData({});
  }, []);

  const handleEditCompany = (company: CompanyProp) => {
    setSelectedCompany(company);
    setShowEditModal(true);
  };

  const handleCloseModal = (isApiReload: boolean) => {
    setShowEditModal(false);
    setSelectedCompany(null);
    if (isApiReload) {
      // Refresh the companies list
      postApiData({});
    }
  };

  return (
    <>
      {contextHolder}
      <Row style={{ marginBottom: "20px" }} gutter={[16, 16]}>
        <Col offset={18} span={6}>
          <NetwalaButton
            backgroundColor={ButtonProps.background.STANDARD}
            height={ButtonProps.height.STANDARD}
            width={ButtonProps.width.STANDARD}
            textColor={ButtonProps.color.STANDARD}
            onClick={() => {
              navigate(`/super-admin/create-company`);
            }}
            text="Create Company"
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }} gutter={30}>
        <Col span={24}>
          <AllCompaniesTable 
            companies={companies} 
            isLoading={apiLoading} 
            onEditCompany={handleEditCompany}
          />
        </Col>
      </Row>
      {selectedCompany && (
        <UpdateCompanyNameModal
          show={showEditModal}
          handleClose={handleCloseModal}
          company={selectedCompany}
        />
      )}
    </>
  );
};
export default AllCompaniesComponent;
